import css from 'styled-jsx/css';

const styles = css.global`footer {
  background-color: #222222;
  padding-bottom: 41px;
}

strong,
span.footer-topics {
  font-size: 24px;
  line-height: 33px;
  margin: 40px 0 10px;
  font-weight: inherit;
}

footer span.footer-topics {
  font-family: "SantanderHeadline";
}

span,
h2,
h3,
strong,
span.footer-topics,
a {
  color: #ffffff;
  font-family: Open Sans;
  text-decoration: none;
}

footer a,
footer a span {
  font-size: 16px;
  line-height: 16px;
}

h3,
strong,
span.footer-topics {
  font-size: 24px;
  line-height: 33px;
  margin: 40px 0 10px;
  font-weight: inherit;
}

.columns span {
  font-size: 16px;
  line-height: 22px;
}

footer .footer-itens span {
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

.categories {
  display: flex;
  justify-content: space-between;
  padding-bottom: 40px;
  flex-wrap: wrap;
  row-gap: 40px;
}

.column div,
.column {
  display: flex;
  flex-wrap: wrap;
}

#categories-footer section[expanded] > :last-child {
  display: flex;
}

.column {
  flex-direction: column;
}

/* #categories-footer section .i-amphtml-fill-content.i-amphtml-replaced-content {
  padding-right: 10%;
} */

.column a {
  margin: 10px 0;
}

.column .active {
  display: flex;
  animation: dropdown 2s;
  position: relative;
}

.box-info {
  overflow: hidden;
}

/* @keyframes dropdown {
  to {
    top: 0;
  }
  from {
    top: -200px;
  }
} */

.infobar {
  border-top: 2px solid #fff;
  padding-top: 38px;
}

.infobar {
  display: flex;
  justify-content: space-between;
}

.infobar .endereco {
  flex-direction: column;
  display: flex;
}

.infobar .endereco span {
  font-family: "SantanderMicroText";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}

.infobar span {
  font-size: 14px;
  line-height: 14px;
}

.endereco span {
  margin: 10px 0;
}

#categories-footer strong,
#categories-footer span.footer-topics {
  border: none;
  background-color: transparent;
  display: flex;
}

.endereco span:nth-child(1) {
  margin-top: 0;
}

.pages {
  display: flex;
}

.pages a {
  margin-right: 32px;
  text-decoration: underline;
  color: #fff;
}

.pages a:last-child {
  margin: 0;
}

#categories-footer {
  display: none;
}

div.content-expanded {
  max-height: 1000px;
}

div.content-hidden {
  max-height: 0;
}

#categories-footer section > div {
  transition: 0.5s ease;
}

/* amp-img {
  margin-right: 10px;
} */

@media (max-width: 992px) {
  .infobar {
    flex-direction: column;
  }
  .pages {
    flex-wrap: wrap;
    margin-top: 32px;
  }
  .pages a {
    margin-right: 15px;
    line-height: 32px;
  }
  .column {
    display: flex;
    flex-wrap: wrap;
    width: 50%;
  }
}

@media (max-width: 768px) {
  .infobar {
    border: none;
  }
  .categories {
    display: none;
  }
  .categories {
    flex-direction: column;
  }
  #categories-footer {
    display: block;
  }
  .column div,
  .column {
    flex-direction: column;
  }
  footer strong,
  footer span.footer-topics {
    font-size: 18px;
    padding-left: 5px;
  }
  #categories-footer section {
    border-bottom: 2px solid aliceblue;
    padding-bottom: 10px;
    padding-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    overflow: hidden;
  }
  #categories-footer section a {
    font-size: 14px;
    padding-left: 5px;
  }
  footer {
    padding-top: 28px;
  }

  .column div.acc-head {
    flex-direction: row;
  }
}

@media (max-width: 500px) {
  .endereco span {
    max-width: 300px;
  }
}

.acc-head,
.acc-block {
  background-color: transparent;
  margin: 0;
  width: 100%;
  height: 33px;
  box-sizing: border-box;
  padding: 0;
  outline: none;
  box-shadow: none;
  border: none;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  position: relative;
}

.acc-head span {
  height: 9px;
  width: 15px;
  position: relative;
  display: block;
  margin-right: 16px;
  transition: transform 0.3s ease;
}

.acc-head span.footer-topics {
  width: auto;
  height: auto;
}

.acc-head span.rotate {
  transform: rotate(180deg);
}

.acc-head strong,
.acc-head span.footer-topics {
  margin: 0;
}

@media (min-width: 768px) {
  footer {
    padding-top: 40px;
  }
  footer span.footer-topics,
  footer .footer-itens {
    margin: 0;
  }
  .column {
    gap: 16px;
  }
}

@media (min-width: 992px) {
  .column {
    width: 241px;
  }
  .column:last-child {
    width: 246px;
  }
}`;

export default styles;